// app.js 
// Contains Layout specific customisation functions

$(document).foundation();

$(function(){

  $('.product-caption h4').matchHeight();
  $('.card-collection').matchHeight();
  $('.card-news .card-section h4').matchHeight();
  
  $('.products-slick').slick({
    slidesToShow: 5,
    arrows: true,
    dots: false,
    infinite: false,
    responsive:[{
        breakpoint: 1119,
        settings:{
            slidesToShow: 4
        }
    },{
        breakpoint: 1023,
        settings:{
            slidesToShow: 3
        }
    },{
        breakpoint: 767,
        settings:{
            slidesToShow: 2,
            dots: true
        }
    },{
        breakpoint: 639,
        settings:{
            slidesToShow: 1,
            dots: true
        }
    }]
  })

	$('[data-toggle="navigation"]').click(function(){
		if($('body').hasClass('navigation-open')){
			$('body').removeClass('navigation-open').height('auto')
			$(this).removeClass('is-active')
		} else {
			$('body').addClass('navigation-open').height($(window).height()).width($(window).width())
			$(this).addClass('is-active')
		}
	})

	if($(window).width()<640){
		$('.footer-menu-wrap h3').click(function(){
			var target = $(this).next('.footer-menu')
			if(target.is(':visible')){
				target.parents('.footer-menu-wrap').removeClass('open')
				target.slideUp()
			} else {
				target.parents('.footer-menu-wrap').addClass('open')
				target.slideDown()
			}
		})
	}

	if($('#lightSlider').length>0){
		var options = {
	    gallery: true,
	    item: 1,
	    loop: true,
			slideMargin: 0,
			vertical:true,
      verticalHeight:466,
      vThumbWidth:116,
	    thumbItem: 4,
	    thumbMargin: 0,
	    enableTouch:true,
	    enableDrag:true,
			controls: false,
			responsive : [
					{
							breakpoint:1199,
							settings: {
									verticalHeight:430,
									vThumbWidth:108,
								}
					},
					{
							breakpoint:480,
							settings: {
									item:2,
									slideMove:1
								}
					}
			]
		};
		if($(window).width()<1024){
			options = {
				gallery: true,
				item: 1,
				loop: true,
				slideMargin: 0,
				thumbItem: 4,
				thumbMargin: 0,
				enableTouch:true,
				enableDrag:true,
				controls: false,
			}
		}
		$('#lightSlider').lightSlider(options);
	}
  
  // Newsletter terms
  $('body').on('click', '[data-newsletter-signup]', function() {
    if ($('#newsletter-check').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("Bitte stimmen Sie unseren Datenschutzbestimmungen zu bevor Sie sich zu unserem Newsletter anmelden.");
      return false;
    }
  });
});